// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"743":"b17744bc","6883":"82675c00"}[chunkId] + ".chunk.css";
};